import React, { FC } from "react";
import icons from "./icons.json";
import cx from "classnames";
import styles from "./Icon.module.scss";

/*
 * This is a limited set of Prism icons. The values below map to the Prism icon names in Figma,
 * i.e. the "Alert/Circle" icon in Figma equals "alert_circle" below.
 * https://www.figma.com/file/Z1YK3COkqNg8MzSTlkCFJn/Universal-Structure-Library?node-id=405%3A14
 *
 */

export const iconOptions = icons._keys;
export interface IconProps {
  name: keyof typeof icons._keys;
  size?: number;
  color?: string;
  style?: any;
  className?: any;
  render?: (icon: JSX.Element) => JSX.Element;
}

interface IIconSrcProps {
  width: number;
  height: number;
  nodes: Record<string, any>[];
}
const Icon: FC<IconProps> = (props) => {
  const { name, size = 48, color, style, className } = props;
  const iconSrc: IIconSrcProps = icons[name];

  const icon = (
    <svg
      width={size}
      height={size}
      fill={color}
      viewBox={`0 0 ${iconSrc.width} ${iconSrc.height}`}
      aria-hidden={true}
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      className={cx(styles.icon, className)}
    >
      {iconSrc.nodes?.map((node, index) => (
        <React.Fragment key={`node-${name}-${index}`}>
          {node.type === "path" && (
            <path d={node.d} fillRule="evenodd" clipRule="evenodd" />
          )}
          {node.type === "circle" && (
            <circle
              cx={node.cx}
              cy={node.cy}
              r={node.r}
              fillRule="evenodd"
              clipRule="evenodd"
            />
          )}
        </React.Fragment>
      ))}
    </svg>
  );

  if (props.render) {
    return props.render(icon);
  }

  return icon;
};

export default Icon;
